import React, { useRef } from 'react';
import { Backdrop, Box, CircularProgress } from '@mui/material';
import pxToRem from 'assets/theme/function/px-to-rem';
import SideBar from 'layouts/protected/side-bar';
import Header from 'layouts/protected/header';
import colors from 'assets/theme/base/colors';
import { Outlet } from 'react-router';
import ConfirmationDialog from 'component/confirmation-dialog';
import { menuItems } from 'routes/routes';
import { useAppSelector } from 'hooks/redux';
import { selectWithdrawalDialogOptions } from 'store/slices/backdrop/backdrop-slice';

const ProtectedLayout = () => {
    const contentRef = useRef<HTMLDivElement>(null);
    const { open } = useAppSelector(selectWithdrawalDialogOptions);

    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                height="100vh"
                overflow="hidden"
                maxWidth={pxToRem(1920)}
                margin="auto"
            >
                <Box sx={{ flexShrink: 0 }}>
                    <Header />
                </Box>

                <Box display="flex" flex="1" minHeight={0}>
                    <SideBar menuItems={menuItems} />
                    <Box
                        ref={contentRef}
                        component="main"
                        flex="1"
                        overflow="auto"
                        pb={pxToRem(20)}
                        pt={pxToRem(10)}
                        bgcolor={colors.background.default}
                        sx={{
                            pr: {
                                xs: pxToRem(10),
                                sm: pxToRem(12),
                                md: pxToRem(20),
                            },
                            pl: {
                                xs: pxToRem(10),
                                sm: pxToRem(22),
                                md: pxToRem(30),
                            },
                        }}
                    >
                        <Backdrop
                            sx={(theme) => ({
                                color: '#fff',
                                zIndex: theme.zIndex.drawer + 1,
                            })}
                            open={open}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                        <Outlet />
                    </Box>
                </Box>
            </Box>
            <ConfirmationDialog />
        </>
    );
};

export default ProtectedLayout;
